<template>
     <div class="mt-5">
            <p class="text-center text-2xl font-bold font-poppins">DATA PER {{antrianPoliData.data_per}}</p>
    </div>
    <div class="rounded-lg p-5 mt-3 font-poppins text-center w-72 flex flex-col justify-center items-center bg-primary text-white font-bold">
        <div class="w-full border-b-4 border-gray-300 pb-3">
            <p class="text-center">{{antrianPoliData.poli}}</p>
        </div>
        <div class="w-full mt-2 mb-2 border-b-4 border-gray-300 pb-4">
            <p class="text-center">TOTAL ANTRIAN</p>
            <p class="text-center">{{antrianPoliData.totalAntrian}}</p>
        </div>
        <hr/>
        <div class="w-full pb-3">
            <p class="text-center">JUMLAH TERLAYANI</p>
            <p class="text-center">{{antrianPoliData.jumlahTerlayani}}</p>
        </div>
    </div>
    <div class="font-poppins mt-5">
        <p class="font-sm">Jumlah terlayani adalah jumlah yang telah selesai diperiksa dokter</p>
    </div>
    <div class="rounded-lg p-5 mt-3 font-poppins text-center w-72 flex flex-col justify-center items-center bg-primary text-white font-bold">
        <div class="w-full border-b-4 border-gray-300 pb-3">
            <p class="text-center">JAM MULAI PEMERIKSAAN</p>
            <p class="text-center">{{ antrianPoliData.jamMulaiPeriksa }}</p>
        </div>
        <div class="w-full mt-2 mb-2 border-b-4 border-gray-300 pb-4">
            <p class="text-center">JAM SELESAI PEMERIKSAAN</p>
            <p class="text-center">{{ antrianPoliData.jamSelesaiPeriksa }}</p>
        </div>
        <hr/>
        <div class="w-full pb-3">
            <p class="text-center">NO PANGGILAN TERAKHIR</p>
            <p class="text-center">{{antrianPoliData.noPanggilAkhir}}</p>
        </div>
    </div>
    <div class="font-poppins mt-5">
        <p class="font-sm">data diperbaharui pada : <span class="text-red-500">{{ timerCount }}</span></p>
    </div>
</template>

<script>
export default {
    data(){
        return {
            timerCount: 10,
            antrianPoliData: this.antrianPoli
        }
    },  
    methods: {
        getAntrianPoli(){
            this.$inertia.get(
                "/admin/antrian_per_poli/ajax/"+this.poli,
                {
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.antrianPoliData = page.props.additional.antrianPerPoli;
                        this.timerCount = 10;
                    },
                }
            );
        }
    },
    watch: {
        timerCount:{
            handler(value){
                if(value > 0){
                    setTimeout(()=>{
                        this.timerCount--;
                    },1000);
                }else{
                    this.getAntrianPoli();
                }
            },
            immediate: true 
        }
    },  
    props: {
        antrianPoli: Object,
        poli: String
    }
};
</script>
